import {mapGetters, mapState} from "vuex";

export default {
  data: () => ({}),
  computed: {
    ...mapState({
      self: state => state.auth.self,
    }),
    ...mapGetters({
      providerLevelType: 'auth/providerLevelType',
      isEntraEnabled: 'office/backupSettings/isEntraEnabled',
      accessLevel: 'auth/accessLevel'
    }),
    currentTenant() {
      return Array.isArray(this.self.providerTenants)
        ? this.self.providerTenants.find(
          t => t.providerTenantName.toLowerCase() === this.$providerTenant.toLowerCase()
        )
        : undefined;
    },
    isPersonalTenant() {
      return this.currentTenant?.levelType === 2;
    },
  },
  methods: {
    // hasProviderAccessRights(levelTypes) {
    //   console.log("levelTypes", levelTypes)
    //   if (!this.providerLevelType && !this.isEntraEnabled) {
    //     return true
    //   }
    //
    //   return levelTypes.includes(this.providerLevelType)
    // },

    // hasEntraIdAccessRights() {
    //   return !!this.isEntraEnabled;
    // }

    hasProviderAccessRights(levelTypes) {
      // Accept both single values and arrays
      const items = Array.isArray(levelTypes) ? levelTypes : [levelTypes];

      if (process.env.VUE_APP_ENVIRONMENT === 'production') {
        const hasEntraFlag = items.some(
          item => typeof item === 'string' && item.replace('!', '') === 'entra-enabled'
        );
        if (hasEntraFlag && this.accessLevel !== 'system-access') {
          return false;
        }
      }

      if (!this.providerLevelType && !this.isEntraEnabled) {
        return true;
      }

      for (const item of items) {
        if (typeof item === 'number') {
          if (this.providerLevelType && item === this.providerLevelType) {
            return true;
          }
          continue;
        }

        // string match flags
        if (typeof item === 'string') {
          const negated = item.startsWith('!');
          const key = negated ? item.slice(1) : item;

          if (key === 'entra-enabled' && !this.isPersonalTenant) {
            const val = !!this.isEntraEnabled;
            if ((val && !negated) || (!val && negated)) return true;
          }
        }
      }

      return false;
    }
  }
}
